import "./SearchClientsContent.css";
import React from "react";
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../helpers/stringAvatar";
import mobileIcon from "./assets/images/mobile.svg";
import emailIcon from "./assets/images/email.svg";
import cnicIcon from "./assets/images/idcard.svg";
import locationIcon from "./assets/images/location.svg";
import { useNavigate } from "react-router-dom";

const SearchClientsContent = ({
  id,
  name,
  dateTime,
  email,
  phone,
  cnic,
  address,
  setOpenSearch,
}) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        setOpenSearch(false);
        navigate(`/user/leads/details/${id}`);
      }}
      className="search-client-detail-card"
    >
      <div className="search-client-detail-header">
        <div className="left">
          <div className="search-client-avatar">
            <Avatar className="name-avatar" {...stringAvatar(name)} />
          </div>
          <div className="search-client-name-container">
            <span className="search-client-name">{name}</span>
            <span className="added-on">
              Added on:{" "}
              <span className="added-date">
                {Date(dateTime)
                  .toLocaleString("en-GB", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                  .split(" ")
                  .slice(0, 4)
                  .join(" ")}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="listing-card-body">
        {/* <div className="detail-buttons">
          {status === "invite" && email !== "" && (
            <span
              className="icon"
              onClick={(e) => {
                e.stopPropagation();
                onInvite();
              }}
            >
              <span>Invite</span>
            </span>
          )}
          {status === "active" && (
            <span
              className="icon"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenActveDialog();
              }}
            >
              <span>Active</span>
            </span>
          )}

          {status === "inactive" && (
            <span
              className="icon"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenInActveDialog();
              }}
            >
              <span>In Active</span>
            </span>
          )}
          <span
            className="icon"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <img src={deleteIcon} />
          </span>

          <span
            className="icon"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            <img src={editIcon} />
          </span>
        </div> */}

        {phone && (
          <div className="card-element">
            <svg
              className="icon"
              width="14"
              height="14"
              viewBox="0 0 10 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 8.3485C9 8.5105 8.96795 8.677 8.89985 8.839C8.83175 9.001 8.74362 9.154 8.62744 9.298C8.43115 9.541 8.21482 9.7165 7.97046 9.829C7.7301 9.9415 7.4697 10 7.18928 10C6.78067 10 6.34402 9.892 5.88333 9.6715C5.42263 9.451 4.96194 9.154 4.50526 8.7805C4.0398 8.39805 3.60058 7.97686 3.19129 7.5205C2.78619 7.0624 2.41256 6.5705 2.07361 6.049C1.74512 5.536 1.48072 5.023 1.28843 4.5145C1.09614 4.0015 1 3.511 1 3.043C1 2.737 1.04807 2.4445 1.14422 2.1745C1.24036 1.9 1.39259 1.648 1.60491 1.423C1.86129 1.1395 2.14171 1 2.43816 1C2.55033 1 2.66249 1.027 2.76264 1.081C2.8668 1.135 2.95894 1.216 3.03105 1.333L3.96044 2.8045C4.03255 2.917 4.08463 3.0205 4.12068 3.1195C4.15674 3.214 4.17677 3.3085 4.17677 3.394C4.17677 3.502 4.14872 3.61 4.09264 3.7135C4.04056 3.817 3.96445 3.925 3.8683 4.033L3.56385 4.3885C3.51978 4.438 3.49975 4.4965 3.49975 4.5685C3.49975 4.6045 3.50376 4.636 3.51177 4.672C3.52379 4.708 3.5358 4.735 3.54382 4.762C3.61592 4.9105 3.74011 5.104 3.91637 5.338C4.09664 5.572 4.28893 5.8105 4.49725 6.049C4.71357 6.2875 4.92188 6.508 5.1342 6.7105C5.34251 6.9085 5.51477 7.0435 5.65098 7.1245C5.67101 7.1335 5.69504 7.147 5.72308 7.1605C5.75513 7.174 5.78718 7.1785 5.82324 7.1785C5.89134 7.1785 5.94342 7.1515 5.98748 7.102L6.29194 6.7645C6.39209 6.652 6.48823 6.5665 6.58037 6.5125C6.67251 6.4495 6.76465 6.418 6.8648 6.418C6.94091 6.418 7.02103 6.436 7.10916 6.4765C7.1973 6.517 7.28943 6.5755 7.38959 6.652L8.71557 7.7095C8.81973 7.7905 8.89184 7.885 8.9359 7.9975C8.97596 8.11 9 8.2225 9 8.3485Z"
                stroke="black"
                strokeMiterlimit="10"
              />
            </svg>
            <div className="detail">{phone}</div>
          </div>
        )}
        {email && (
          <div className="card-element">
            <svg
              className="icon"
              width="14"
              height="14"
              viewBox="0 0 11 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.53226 8.40323H3.17742C1.87097 8.40323 1 7.75 1 6.22581V3.17742C1 1.65323 1.87097 1 3.17742 1H7.53226C8.83871 1 9.70968 1.65323 9.70968 3.17742V6.22581C9.70968 7.75 8.83871 8.40323 7.53226 8.40323Z"
                stroke="black"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.53062 3.39453L6.16756 4.48324C5.71901 4.84034 4.98304 4.84034 4.53449 4.48324L3.17578 3.39453"
                stroke="black"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="detail">{email}</div>
          </div>
        )}
        {cnic && (
          <div className="card-element">
            <svg
              className="icon"
              width="14"
              height="14"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.75 7.5671H6.94435M5.77726 7.5671H2.95968M7.75 5.92968H5.34177M4.16597 5.92968H2.95968M4.04839 9.70968H6.66129C8.83871 9.70968 9.70968 8.83871 9.70968 6.66129V4.04839C9.70968 1.87097 8.83871 1 6.66129 1H4.04839C1.87097 1 1 1.87097 1 4.04839V6.66129C1 8.83871 1.87097 9.70968 4.04839 9.70968Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="detail">{cnic}</div>
          </div>
        )}
        {address && (
          <div className="card-element">
            <svg
              className="icon"
              width="14"
              height="14"
              viewBox="0 0 10 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.75324 5.97523C4.93167 5.97523 5.10835 5.94009 5.2732 5.87181C5.43804 5.80352 5.58783 5.70344 5.71399 5.57728C5.84016 5.45111 5.94024 5.30132 6.00852 5.13648C6.07681 4.97163 6.11195 4.79495 6.11195 4.61652C6.11195 4.43809 6.07681 4.26141 6.00852 4.09657C5.94024 3.93172 5.84016 3.78194 5.71399 3.65577C5.58783 3.5296 5.43804 3.42952 5.2732 3.36124C5.10835 3.29296 4.93167 3.25781 4.75324 3.25781C4.39289 3.25781 4.0473 3.40096 3.79249 3.65577C3.53768 3.91058 3.39453 4.25617 3.39453 4.61652C3.39453 4.97687 3.53768 5.32247 3.79249 5.57728C4.0473 5.83208 4.39289 5.97523 4.75324 5.97523V5.97523Z"
                stroke="black"
              />
              <path
                d="M1.10572 3.82629C1.96362 0.055001 7.55088 0.0593559 8.40443 3.83065C8.90523 6.0429 7.5291 7.91549 6.32281 9.07387C5.9013 9.48041 5.33851 9.70758 4.75289 9.70758C4.16727 9.70758 3.60449 9.48041 3.18297 9.07387C1.98104 7.91549 0.60491 6.03855 1.10572 3.82629V3.82629Z"
                stroke="black"
              />
            </svg>
            <div className="detail">{address}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchClientsContent;
